const KlaviyoComponent = ({ newsletter }) => (
  <div className={`klaviyo-form-${newsletter.formId}`} />
);

export default KlaviyoComponent;
